import { render, staticRenderFns } from "./extends-test.vue?vue&type=template&id=0c1c55e0&"
import script from "./extends-test.vue?vue&type=script&lang=ts&"
export * from "./extends-test.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports